import React from "react";

import api from "@api";
import { setTestDriveTypesAction } from "@redux/actions/configActions";
import { i18n } from "@lib/i18n";
import { IS_SERVER } from "@shared/constants";

export function withTestDriveTypes(Component) {
  const hocComponent = props => <Component {...props} />;

  hocComponent.getInitialProps = async (ctx, ...args) => {
    const { store, req } = ctx;
    const { appConfig } = store.getState();

    const i18nInstance = IS_SERVER ? req.i18n : i18n;

    if (!appConfig.testDriveTypes.length) {
      const { data: testDriveTypes } = await api.getTestDriveTypes(
        i18nInstance.language
      );

      store.dispatch(setTestDriveTypesAction(testDriveTypes));
    }

    return Component.getInitialProps?.(ctx, ...args);
  };

  return hocComponent;
}
